import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';

export interface WorkOrder {
  inspectionReportWorkOrderId: string;
  workOrderNumber: string;
  inspectionReportId: string;
}

export class InspectionReportWorkOrder implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Inspection Report Work Order';
  readonly apiRoute: string;

  inspectionReportWorkOrderId: string;
  workOrderNumber: string;
  inspectionReportId: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.inspectionReportWorkOrderId = data.inspectionReportWorkOrderId;
    this.workOrderNumber = data.workOrderNumber;
    this.inspectionReportId = data.inspectionReportId;
  }
}
